var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layerWrapper", class: _vm.getStyle }, [
    _c("div", { staticClass: "cbox layerBox popWidM" }, [
      _c("div", { staticClass: "cart-popup__dialog" }, [
        _c("div", { staticClass: "cart-popup__content height-auto" }, [
          _c(
            "div",
            {
              staticClass: "cart-popup__item-info",
              staticStyle: { padding: "0" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "begin",
                      expression: "isMode == 'begin'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop1.jpg"),
                      alt: "본 이벤트는 이벤트 신청 시간부터 신청 가능합니다."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "joinCompleted",
                      expression: "isMode == 'joinCompleted'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop2.jpg"),
                      alt: "이벤트 신청이 완료되었습니다."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "closed",
                      expression: "isMode == 'closed'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop3.jpg"),
                      alt: "본 이벤트는 종료되어 신청하실 수 없습니다."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "validTerms",
                      expression: "isMode == 'validTerms'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop4.jpg"),
                      alt: "개인정보 수집 동의를 해야만 참여가 가능합니다."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "joinIn",
                      expression: "isMode == 'joinIn'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop5.jpg"),
                      alt: "이미 이벤트에 응모하셨습니다."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "validPhone",
                      expression: "isMode == 'validPhone'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop6.jpg"),
                      alt: "개인정보 수집 동의를 해야만 참여가 가능합니다."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "notJoin",
                      expression: "isMode == 'notJoin'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop7.jpg"),
                      alt: "개인정보 수집 동의를 해야만 참여가 가능합니다."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "validName",
                      expression: "isMode == 'validName'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop8.jpg"),
                      alt: "이름을 입력하여 주세요."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "validPhoneEmpty",
                      expression: "isMode == 'validPhoneEmpty'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop9.jpg"),
                      alt: "핸드폰 번호를 입력하여 주세요."
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMode == "validAboNumber",
                      expression: "isMode == 'validAboNumber'"
                    }
                  ],
                  staticClass: "os_noticeRes",
                  attrs: { "data-btn-close": "closeLayer" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("../images/a7070xgri_pop10.jpg"),
                      alt: "ABO/Member/소비자번호를 입력하여 주세요."
                    }
                  })
                ]
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c172c0a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172c0a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/a7070-glister/component/layerPopup.vue
// module id = null
// module chunks = 